import React from 'react';
import './ActNaut.css';
import {Card,Accordion} from 'react-bootstrap'

export default function Wing() {
    return (
        <div>
<div className="containerAN">
        <section className="banner-module">
        <div className="banner banner-four1">

<span className="headline">CURSO DE <br/>WINGFOIL</span>
</div>
<div className="banner banner-three-title">
  
   
<h1 className="title-socio title-none">
CURSO DE WINGFOIL
 </h1>
            </div>

            <div className="banner banner-one">

            <Card >
  <Card.Body>
    <Card.Title className="title-act">CURSO DE <br/>PRINCIPIANTE</Card.Title>
    <Card.Text>
      <ul className="list-act">
        <li><b className='duracion'>Duración:</b><br/> 1, 2 o 3 sesiones</li>
        <li><b className='duracion'>Tamaño grupo:</b><br/> 1- 3 pers.</li>
        <li className="price"><b>Desde 60 €</b> </li>
      </ul>
    </Card.Text>
    <a className="button-act-align" href="https://windsurfsantapola.playoffinformatica.com/actividad/41/CURSO-WINGFOIL-2026"> <button className="button-act" >Solicitud</button></a>
  </Card.Body>
</Card>
{/* <img className="oferta" src="/oferta.png" alt="oferta" width="120"/> */}
<p className="astAN">* En todas las actividades a los asociados/as individuales se les aplicará un descuento del 20%, y a los familiares un 30% <a href="/socio"> Hazte socio aquí</a></p>
            </div>


            <div className="banner banner-two">
            <Card>
            <Card.Body>
  <Card.Title className="title-act">CURSO DE <br/>AVANZADO</Card.Title>
    <Card.Text>
      <ul className="list-act">
        <li><b className='duracion'>Duración:</b><br/> 2 horas</li>
        <li><b className='duracion'>Tamaño grupo:</b><br/> 1- 3 pers.</li>
        <li className="price"><b>99 €</b></li>
      </ul>
    </Card.Text>
    <a className="button-act-align" href="https://windsurfsantapola.playoffinformatica.com/actividad/41/CURSO-WINGFOIL-2026"> <button className="button-act" >Solicitud</button></a>
  </Card.Body>
</Card>
<p className="astAN">* En todas las actividades a los asociados/as individuales se les aplicará un descuento del 20%, y a los familiares un 30% <a href="/socio"> Hazte socio aquí</a></p>
            </div>
            
            <div className="clear-fix"></div>
            

            <div className="banner banner-three">
            <Accordion defaultActiveKey="1">
  <Accordion.Item eventKey="0">
    <Accordion.Header ><Card.Title className="title-act-1"> Descripción del Curso</Card.Title></Accordion.Header>
    <Accordion.Body>
    <Card>
  <Card.Body>
    <Card.Text>
    <h3 className="h3-act p-act-3">Duración</h3>
<p className="p-act-1">• Las sesiones tienen una duración aproximada de <b>90 minutos</b>.</p>
<p className="p-act-1">• Según las habilidades de cada persona, podrá ser necesario realizar las sesiones de iniciación recomendadas por los instructores antes de pasar al nivel avanzado.</p>
<p className="p-act-1">• Las sesiones son de <b>90 minutos al día</b>. Si haces varias, no es necesario que sean en días consecutivos.</p>
<p className="p-act-1">Puedes elegir turno de mañana (10:30 a 12:00 o 12:00 a 13:30) o de tarde (16:00 a 17:30 o 18:00 a 19:30). Consulta la disponibilidad con nuestro equipo.</p>
<p className="p-act-1">*El curso tendrá validez hasta diciembre del año en que comiences la primera clase.</p>

<h3 className="h3-act p-act-4">Descripción del curso</h3>
<p className="p-act-1">
  A través de este curso aprenderás las nociones básicas necesarias para practicar de forma autónoma.  
  Comenzaremos en la arena, con una introducción teórica y práctica sobre el deporte, las partes del equipo, el manejo de la cometa y los rumbos básicos.  
  Después, usaremos una tabla de SUP para aprender a levantarnos y colocarnos, practicando el control de la cometa, con el objetivo de realizar un giro básico y regresar al punto de salida.  
  Estas sesiones iniciales son una primera toma de contacto.  
  Una vez controlada la cometa, accederás al nivel avanzado, donde aprenderás a volar con foil y a realizar diferentes tipos de giros y rumbos.
</p>
<p className="p-act-1">*Nos adaptamos al ritmo de aprendizaje de cada persona.</p>
<p className="p-act-1">*La realización de los cursos puede variar según la meteorología y la disponibilidad.</p>

<h3 className="h3-act p-act-3">¿Qué incluye la actividad?</h3>
<ul className="list-act">
  <li className="p-act-1">• Material necesario para la actividad</li>
  <li className="p-act-1">• Monitores titulados</li>
  <li className="p-act-1">• Clases teóricas y prácticas</li>
  <li className="p-act-1">• Licencia de Escuela</li>
  <p className="p-act-1">• Respetar normas vigentes de <a href="https://www.mitma.gob.es/marina-mercante/nautica-de-recreo/normas-de-seguridad-y-recomendaciones">capitanía marítima</a> y <a href="http://www.salvamentomaritimo.es/mejora-tu-seguridad">salvamento.</a></p>
</ul>
    </Card.Text>
  </Card.Body>
</Card>
    </Accordion.Body>
  </Accordion.Item>
  </Accordion>
            </div>

    
           
        </section>
    </div>
        </div>
    )
}
